export class Translator {
  locations = {}
  currentLocale = null
  sourceLocale = null

  constructor(options = {}) {
    this.sourceLocale = options.sourceLocale || null
  }

  registerLocations(locations) {
    this.locations = locations
  }

  registerLocation(key, location) {
    this.locations[key] = location
  }

  async changeLocale(targetLocale) {
    if (targetLocale === this.sourceLocale) {
      this.putBackOriginalTexts()
    } else {
      await this.translate(targetLocale)
    }
    this.currentLocale = targetLocale
  }

  async translate(targetLocale, onlyLocation = '', forceRefresh = false) {
    if (
      this.currentLocale &&
      targetLocale === this.currentLocale &&
      !forceRefresh
    ) {
      console.warn(
        'Trying to set language to ' + targetLocale + ' but its already set'
      )
      return
    }
    const locationsArray = []
    const locationsToTranslate = Object.entries(this.locations).filter(
      ([key]) => !onlyLocation || onlyLocation === key
    )
    for (const [key, location] of locationsToTranslate) {
      const texts = location.findTexts()
      locationsArray.push({
        location: key,
        texts,
      })
    }
    const res = await fetch('/api/translate', {
      method: 'POST',
      body: JSON.stringify({
        locations: locationsArray,
        targetLocale,
        sourceLocale: document.documentElement.lang,
      }),
    })
    const json = await res.json()
    for (const [key, { translations }] of Object.entries(json.locations)) {
      if (this.locations?.[key] && translations) {
        this.locations[key].setTranslations(translations)
      }
    }
  }

  async refreshTranslation(onlyLocation = '') {
    await this.translate(this.currentLocale, onlyLocation, true)
  }

  putBackOriginalTexts() {
    for (const location of Object.values(this.locations)) {
      location.revert()
    }
  }
}
